<template>
	<div v-if="coverageYears.length" class="coverage-grid">
		<div v-for="row in coverageYears" :key="row.year" class="coverage-row">
			<span class="coverage-year">{{ row.year }}</span>
			<span
				v-for="m in 12"
				:key="m"
				class="coverage-cell"
				:class="{ 'is-loaded': row.months[m] }"
				v-tooltip.top="coverageTitle(row.year, m, row.months[m])"
			>
				{{ monthInitial(m) }}
			</span>
		</div>
	</div>
</template>

<script>
// Grid de cobertura mensual (año × 12): la celda teal es mes con datos.
// Compartido por las secciones de subida de la ficha (ventas/costos y mayor):
// recibe la cobertura ya derivada por el backend y no toca Vuex ni la API.
// El label/eyebrow lo pone el padre (cada sección tiene su propio estilo).
const MONTH_INITIALS = ["E", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
const MONTH_NAMES = [
	"Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
	"Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre",
];

export default {
	name: "MonthCoverageGrid",
	props: {
		// [{month: "YYYY-MM", documents: n}] ordenado cronológicamente.
		monthsLoaded: {
			type: Array,
			default: () => [],
		},
	},
	computed: {
		// Agrupada por año para el grid: [{year, months: {1..12: docs}}],
		// del año más viejo al más nuevo.
		coverageYears() {
			const byYear = {};
			this.monthsLoaded.forEach((item) => {
				const [year, month] = item.month.split("-");
				if (!byYear[year]) byYear[year] = {};
				byYear[year][parseInt(month, 10)] = item.documents;
			});
			return Object.keys(byYear)
				.sort()
				.map((year) => ({ year, months: byYear[year] }));
		},
	},
	methods: {
		monthInitial(month) {
			return MONTH_INITIALS[month - 1];
		},
		coverageTitle(year, month, documents) {
			const name = `${MONTH_NAMES[month - 1]} ${year}`;
			if (!documents) return `${name}: sin documentos`;
			return documents === 1
				? `${name}: 1 documento`
				: `${name}: ${documents} documentos`;
		},
	},
};
</script>

<style scoped lang="scss">
// Tema del analista (var(--ap-*), elements/_analyst_theme.scss).
.coverage-grid {
	display: flex;
	flex-direction: column;
	gap: 4px;
}

.coverage-row {
	display: flex;
	align-items: center;
	gap: 4px;
}

.coverage-year {
	flex: none;
	width: 40px;
	font-size: 11px;
	font-weight: 600;
	color: var(--ap-slate);
	font-variant-numeric: tabular-nums;
}

.coverage-cell {
	flex: 1;
	max-width: 36px;
	height: 24px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	font-size: 10px;
	font-weight: 600;
	color: var(--ap-muted);
	background-color: var(--ap-mist);
	border: 1px solid var(--ap-line);
	border-radius: var(--ap-radius-sm);
	cursor: default;
}

.coverage-cell.is-loaded {
	color: var(--ap-teal-deep);
	background-color: var(--ap-teal-wash);
	border-color: var(--ap-teal);
}
</style>
